import * as React from "react";

const SearchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <g
      stroke="#D9D9D9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_1900_4277)"
    >
      <path d="M7 12.902a5 5 0 1 0 0-10 5 5 0 0 0 0 10M10.535 11.438 14 14.902"></path>
    </g>
    <defs>
      <clipPath id="clip0_1900_4277">
        <path fill="#fff" d="M0 .902h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SearchIcon;
